import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import googleSheetsLogo from './googleSheetsLogo.png';
import GoogleSmartMenu from '../SmartMenu/GoogleSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const GoogleSheetsLink = ({ children, ...restProps }: Props) => {
  return (
    <SmartLinkContainer contentEditable={false}>
      <GoogleSmartMenu type="sheet" logoName={googleSheetsLogo} {...restProps}>
        <SmartLink {...restProps}>
          <SmartLinkLogo src={googleSheetsLogo} />
          {children}
        </SmartLink>
      </GoogleSmartMenu>
    </SmartLinkContainer>
  );
};

export default GoogleSheetsLink;
